import { supabase } from "../supabase/SupabaseClient";

/* Cuántos hay de cada cosa, para los números del menú.
 *
 * Una sola llamada a la base y no una por tabla: son trece, y trece pedidos en
 * el arranque se notan en el celular.
 *
 * Si falla se devuelve un objeto vacío en vez de tirar error. El menú sin
 * números funciona igual; el menú que no aparece porque se cayó una consulta
 * de adorno, no.
 */
export async function traerConteos() {
  try {
    const { data, error } = await supabase.rpc("conteos");
    if (error) {
      console.warn("[conteos] no se pudieron traer:", error.message);
      return {};
    }
    return data || {};
  } catch (e) {
    console.warn("[conteos] no se pudieron traer:", e);
    return {};
  }
}
